import ProviderForm from '../../ProviderForm'
import useCreateProviderHandler from '../../../effects/create-provider'
import { heapEvent } from '@equipmentshare/heaper'

export type AddProviderModalProps = {
  onCancel: () => void,
  onSuccess: () => void,
}

export default function AddProviderModal( { onCancel, onSuccess }: AddProviderModalProps ): JSX.Element {
	const createProvider = useCreateProviderHandler()

	const handleSubmit = async( provider: any ) => {
		heapEvent( 'Inventory - Add Manufacturer Modal - Click - Submit', {} )
		return await createProvider( provider )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Manufacturer Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ProviderForm
			canMerge
			onCancel={handleCancel}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
		/>
	)
}
